import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import ContinueButton from "@components/ContinueButton";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useSiteMetadata } from "../../hooks/use-site-metadata";
import { makeStyles } from "../../hooks/make-styles-wrapper";

const useContainerStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            {
                display: "flex",
                flexDirection: "column",
            },
            overrides,
        ),
    }),
    "submitBlurb.container",
);

const useTosContainerStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            {
                width: "400px",
                fontSize: "13px !important",
                fontStyle: "italic",
                marginBottom: "40px",

                [theme.breakpoints.down(350)]: {
                    width: "275px",
                    marginBottom: "50px",
                },
                [theme.breakpoints.between(350, 360)]: {
                    marginBottom: "30px",
                },
                [theme.breakpoints.between(350, 390)]: {
                    width: "300px",
                },
                [theme.breakpoints.between(390, 440)]: {
                    width: "350px",
                },
            },
            overrides,
        ),
    }),
    "submitBlurb.tosContainer",
);

const useTosStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            {
                fontSize: "12.5px",
                textAlign: "center",
                lineHeight: 1.8,
            },
            overrides,
        ),
    }),
    "submitBlurb.tos",
);

const useButtonStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            {},
            overrides,
        ),
    }),
    "submitBlurb.button",
);

const SubmitBlurb = (props) => {
    const {
        buttonText,
        body1,
        body2,
        index,
        name,
        onComplete,
    } = props;

    const [isSubmitting, setIsSubmitting] = useState(false);
    const { customLayout } = useSiteMetadata();
    const containerStyles = useContainerStyles();
    const tosContainerStyles = useTosContainerStyles();
    const tosStyles = useTosStyles();
    const buttonStyles = useButtonStyles();

    const spinnerBoxProps = {
        visibility: isSubmitting ? "visible" : "hidden",
        marginBottom: "20px",
        clone: true,
    };
    const spinnerProps = {
        color: "primary",
    };

    const handleOnClick = async (e) => {
        setIsSubmitting(true);
        await onComplete(index);
    };

    return (
        <Box className={containerStyles.root}>
            <Box className={tosContainerStyles.root}>
                <Box className={tosStyles.root}>
                    {body1}
                </Box>
                <Box className={tosStyles.root}>
                    {body2}
                </Box>
            </Box>
            <ContinueButton
                onClick={handleOnClick}
                text={buttonText}
                overrideWidth="100% !important"
                className={buttonStyles.root}
            />
            {customLayout &&
                <LoadingSpinner
                    boxProps={spinnerBoxProps}
                    spinnerProps={spinnerProps}
                />
            }
        </Box>
    );
};

export default SubmitBlurb;